import { Navigation } from "@/components/Navigation";
import { Card, CardHeader, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Session } from "@supabase/supabase-js";

interface PricingProps {
  session: Session | null;
}

const Pricing = ({ session }: PricingProps) => {
  return (
    <div className="min-h-screen bg-skuhub-navy">
      <Navigation session={session} />
      <div className="container mx-auto px-4 py-24">
        <h1 className="text-4xl font-bold text-center text-white mb-12">
          Simple, transparent pricing
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Basic Tier */}
          <Card className="bg-white/5 backdrop-blur-sm border-white/10 hover:bg-white/10 transition-colors">
            <CardHeader>
              <h3 className="text-2xl font-bold text-white">Basic</h3>
              <p className="text-gray-400">For small businesses</p>
              <div className="mt-4">
                <span className="text-4xl font-bold text-white">$0</span>
                <span className="text-gray-400">/month</span>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="space-y-3 text-gray-300">
                <li>$1 per vendor</li>
                <li>$0.001 per item ingested through API</li>
                <li>Basic support</li>
              </ul>
            </CardContent>
            <CardFooter>
              <Button className="w-full bg-white/10 hover:bg-white/20">
                Get Started
              </Button>
            </CardFooter>
          </Card>

          {/* Pro Tier */}
          <Card className="bg-white/5 backdrop-blur-sm border-white/10 hover:bg-white/10 transition-colors transform scale-105">
            <CardHeader>
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-skuhub-coral px-3 py-1 rounded-full text-sm text-white">
                Most Popular
              </div>
              <h3 className="text-2xl font-bold text-white">Pro</h3>
              <p className="text-gray-400">For retail teams</p>
              <div className="mt-4">
                <span className="text-4xl font-bold text-white">$100</span>
                <span className="text-gray-400">/month</span>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="space-y-3 text-gray-300">
                <li>Unlimited vendors</li>
                <li>$0.0005 per item ingested through API</li>
                <li>Priority support</li>
              </ul>
            </CardContent>
            <CardFooter>
              <Button className="w-full bg-gradient-to-r from-skuhub-coral to-skuhub-orange hover:opacity-90">
                Get Started
              </Button>
            </CardFooter>
          </Card>

          {/* Enterprise Tier */}
          <Card className="bg-white/5 backdrop-blur-sm border-white/10 hover:bg-white/10 transition-colors">
            <CardHeader>
              <h3 className="text-2xl font-bold text-white">Enterprise</h3>
              <p className="text-gray-400">For large organizations</p>
              <div className="mt-4">
                <span className="text-2xl font-bold text-white">Custom pricing</span>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <ul className="space-y-3 text-gray-300">
                <li>Custom solutions</li>
                <li>Dedicated support team</li>
                <li>Custom integrations</li>
              </ul>
            </CardContent>
            <CardFooter>
              <Button className="w-full bg-white/10 hover:bg-white/20">
                Contact Sales
              </Button>
            </CardFooter>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
